import { render, staticRenderFns } from "./EntityReationshipDataTable.vue?vue&type=template&id=44ef5fb9&scoped=true"
import script from "./EntityReationshipDataTable.vue?vue&type=script&lang=js"
export * from "./EntityReationshipDataTable.vue?vue&type=script&lang=js"
import style0 from "./EntityReationshipDataTable.vue?vue&type=style&index=0&id=44ef5fb9&prod&lang=scss&scoped=true"
import style1 from "./EntityReationshipDataTable.vue?vue&type=style&index=1&id=44ef5fb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ef5fb9",
  null
  
)

export default component.exports